import { IcoDownloadCloudArrowSmall } from '@icons';
import { UseMutationResult } from '@tanstack/react-query';
import React from 'react';
import { Button } from 'react-bootstrap';

interface SummaryDownloadBoxProps {
	checklist: {
		key: string;
		label: React.ReactNode;
		mutation: UseMutationResult<
			| {
					success: boolean;
					message?: undefined;
			  }
			| {
					success: boolean;
					message: any;
			  },
			Error,
			void,
			unknown
		>;
	};
}

const SummaryDownloadBox: React.FC<SummaryDownloadBoxProps> = ({ checklist }) => {
	return (
		<div
			key={checklist.key}
			style={{
				padding: '1rem',
				border: '1px solid #2A3A64',
				borderRadius: '8px',
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				maxWidth: '800px',
				width: '100%',
				margin: '0 auto',
			}}
		>
			<span>{checklist.label}</span>
			<Button
				onClick={() => {
					checklist.mutation.mutate();
				}}
				className="btn custom-primary-button"
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					gap: '0.5rem',
					minWidth: '175px',
					height: '48px',
				}}
			>
				<IcoDownloadCloudArrowSmall />
				Scarica
			</Button>
		</div>
	);
};

export default SummaryDownloadBox;
